import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../../../app/axios";
import { API_URL } from "../../../app/config";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ICareerDetails } from "../careerModel";

export const updateCareer = createAsyncThunk(
  "Carrer/InsertCarrer",
  async (UserData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Carrer/InsertCarrer`,
        UserData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating career details:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getCareerDetails = createAsyncThunk(
  "Carrer/GetCarrerDetail",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Carrer/GetCarrerDetail`
      );
      const result = response.data?.Data as any;
      return {
        BannerImage: result?.BannerImage || "",
        Description: result?.Description || "",
        CarrerImages: result?.CarrerImages || [],
      } as ICareerDetails;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching career details:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteCareerImage = createAsyncThunk(
  "Carrer/CarrerImageDelete",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Carrer/CarrerImageDelete`,
        { ID: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting career images:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
